import { FormControl, FormControlProps, FormHelperText, FormLabelProps, InputLabel, InputLabelProps, MenuItem, MenuItemProps, OutlinedInput, Select, SelectChangeEvent, SelectProps } from '@mui/material'
import React, { useEffect, useState } from 'react'
import { ICtrlList, ICtrlParam } from './models'

export interface CtrlParamsSelectComponentProps {
  ctrl: ICtrlList,
  helperText?: string | null,
  rootProps?: FormControlProps,
  selectProps?: SelectProps,
  labelProps?: InputLabelProps,
  itemProps?: MenuItemProps,
}

export const CtrlParamsSelectComponent = (props: CtrlParamsSelectComponentProps) => {
  const [value, setValue] = useState<any>(props.ctrl.items[0].value)

  useEffect(() => {
    setValue(props.ctrl.items[0].value)
  }, [props.ctrl])

  return <>
    <FormControl {...props.rootProps} fullWidth={props.rootProps?.fullWidth ?? true}>
      <InputLabel {...props.labelProps} id={props.labelProps?.id ?? `select-label-${props.ctrl.uuid}`}>{(props.ctrl as ICtrlParam).label}</InputLabel>
      <Select
        {...props.selectProps}
        input={props.selectProps?.input ?? <OutlinedInput label={(props.ctrl as ICtrlParam).label} />}
        labelId={props.selectProps?.labelId ?? `select-label-${props.ctrl.uuid}`}
        value={props.selectProps?.value ?? value}
        fullWidth={props.selectProps?.fullWidth ?? true}
        onChange={(e, child) => {
          setValue(e.target.value)
          if (props.selectProps?.onChange)
            props.selectProps.onChange(e, child)
        }}
      >
        {(props.ctrl as ICtrlList).items?.map((i, idx) =>
          <MenuItem {...props.itemProps} key={idx} value={i.value}>{i.label}</MenuItem>)}
      </Select>
      {props.helperText && <FormHelperText>{props.helperText}</FormHelperText>}
    </FormControl>
  </>
}